import { auth0ApiClient } from './auth0ApiClient'
import { User } from '@/types/user'

interface SearchUsersResponse {
  users: User[]
}

class UserSearchService {
  private readonly baseUrl = '/users'

  async searchUsers(query: string): Promise<User[]> {
    const response = await auth0ApiClient.get<SearchUsersResponse>(`${this.baseUrl}/search`, {
      params: { q: query }
    })
    return response.users
  }

  async getUserById(id: string): Promise<User> {
    return auth0ApiClient.get<User>(`${this.baseUrl}/${id}`)
  }
}

export const userSearchService = new UserSearchService()
